/** VERSION: 1.0.0 Please do not delete this line. Thank you! **/
// Override Settings
var boostPFSInstantSearchConfig = {
    search: {
        suggestionStyle: 'style2',
        suggestionStyle2MainContainerSelector: '.predictive-search .drawer__content',
        suggestionStyle2ProductPerRow: 2, //  2, 3
        //suggestionMode: 'test',
        //suggestionPosition: 'left'
    }
};

(function() {
    BoostPFS.inject(this);

    // Customize style of Suggestion box
    SearchInput.prototype.customizeInstantSearch = function() {
        var suggestionElement = this.$uiMenuElement;
        var searchElement = this.$element;
        var searchBoxId = this.id;
    };

    // Bind Event for input search Mobile
    var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
    InstantSearchMobile.prototype.bindEvents = function() {
        bindEventsMobile.call(this);

        var self = this;
        var searchButtonMobile = 'a.header__icon-wrapper[href="/search"], .search-button, .js-search-destop';
        var searchInputMobile = '.search-input-group input[type="search"], .wg-search-form .search-input';
        var searchCloseButtonMobile = '.drawer__close > button, .drawer_back a';
        jQ(searchButtonMobile).off('click').click(function(e) {
         
            e.preventDefault();
            e.stopPropagation();
            jQ(searchInputMobile).focus();
            self.openSuggestionMobile();
            jQ(searchCloseButtonMobile).trigger('click');

        });
    }

    // Bind Event for input search style 3
    var bindEvents = InstantSearchStyle3.prototype.bindEvents;
    InstantSearchStyle3.prototype.bindEvents = function() {
        bindEvents.call(this);
        var self = this;
        var searchButtonDesktop = '.site-header__links .search-button';
        var searchInputDesktop = '#SearchContainer #search-input';
        var searchCloseButtonDesktop = '.drawer__close > button';
        jQ(searchButtonDesktop).off('click').click(function(e) {
            e.preventDefault();
            e.stopPropagation();
            jQ(searchInputDesktop).focus();
            self.openSuggestionStyle3();
            jQ(searchCloseButtonDesktop).trigger('click');

        });
    }

    // Fix search for the Flow theme
    jQ('.site-header__links .search-button').on('click', function() {
        setTimeout(function() {
            boostPFS.initSearchBox();
            if (Utils.isCollectionPage()) jQ('.search-input-group > .boost-pfs-search-box').val('');
        }, 500);
    });

    /* Start boost 150149 */
    SearchAutoComplete.prototype.bindEvents = function() {
        if (this.$element && this.parent.instantSearchResult.$wrapper && this.$inputElement) {
            this.currentTerm = Utils.stripHtml(this.$inputElement.val());
            this.searchResult.$wrapper.append(this.$element);

            // Arrow keys events
            this.$inputElement.on('keydown', this._onKeyboardEnter.bind(this));
            this.$inputElement.on('keyup', this._onKeyboardNavigation.bind(this));

            // Search result events
            this.$element.on('focus', this.searchInput.onFocusAutocomplete.bind(this.searchInput));
            this.$element.on('click', this.searchInput.onSelectAutocomplete.bind(this.searchInput));
            if (Utils.isMobile()) {
                document.addEventListener('click', this._onClose.bind(this), true);
            }

            // Input events
            this.$inputElement.on('click', this._onOpen.bind(this));
            this.$inputElement.on('keyup', Utils.debounce(this._onKeyUp.bind(this), this.delay));
        }
    };
    /* End boost 150149 */

    //felippe boost 152913 - if there is a per Yard variant, show price per yards, instead of sample price
    InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function() {
        this.prepareSuggestionProductPriceData();
        // Check on sale
        var onSale = this.data.compare_at_price_min > this.data.price_min;
        // Format price
        //default case
        var price = Utils.formatMoney(this.data.price_min);

        //yard variant case
        let variants = this.data.variants;
        const isYardVariant = (variant) => {
            return variant.title.includes("Yard")
        }
      
        let thereisYardVariant = variants.some((variant) => isYardVariant(variant))


        if (thereisYardVariant) {
            let yardVariants = variants.filter((variant) => isYardVariant(variant))
         

            price = Utils.formatMoney(+yardVariants[0].price);

        }

        //end yard variant case

        var compareAtPrice = '';
        if (this.data && this.data.compare_at_price_min) {
            compareAtPrice = Utils.formatMoney(this.data.compare_at_price_min);
            if (Settings.getSettingValue('search.removePriceDecimal')) {
                price = Utils.removeDecimal(price);
                compareAtPrice = Utils.removeDecimal(compareAtPrice);
            }
        }

        // Build Price
        var result = '';
        if (Settings.getSettingValue('search.showSuggestionProductPrice')) {
            if (onSale && Settings.getSettingValue('search.showSuggestionProductSalePrice')) {
                result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE_SALE);
            } else {
                result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE);
            }
        }

        var priceVaries = this.data.price_min != this.data.price_max; // Check a product has many prices
        if (priceVaries) {
            price = 'From ' + price;
        }


        return result
            .replace(/{{regularPrice}}/g, price)
            .replace(/{{compareAtPrice}}/g, compareAtPrice);


    };

    //end- felippe boost 152913 - if there is a per Yard variant, show price per yards, instead of sample price

    InstantSearchApi.beforeCall = function(searchTerm) {
        /* Change the params before calling api */
        if (boostPFSConfig && boostPFSConfig.general && typeof boostPFSConfig.general.current_currency == "string") {
            Globals.instantSearchQueryParams.currency = boostPFSConfig.general.current_currency.toLowerCase().trim();
            // Pass the currency rate to our api
            if (Shopify && Shopify.currency) {
                Globals.instantSearchQueryParams.currency_rate = Shopify.currency.rate;
            }
        }
        if (Shopify && Shopify.country && typeof Shopify.country == "string") {
            Globals.instantSearchQueryParams.country = Shopify.country.toLowerCase().trim();
        }
        Globals.instantSearchQueryParams.return_all_currency_fields = false;
    }
  
   // Start Boost 218211
//     var hasShopifyRoutes = Shopify && Shopify.routes && typeof Shopify.routes.root != 'undefined';
//     var localeURLPart = "";

//     if (hasShopifyRoutes) {
//         localeURLPart = Shopify.routes.root.replace(/\/$/, '');
//     } else if (elements.indexOf(boostPFSConfig.general.current_locale) > -1) {
//         localeURLPart = "/" + boostPFSConfig.general.current_locale;
//     }
  
//     InstantSearchResultItemProduct.prototype.afterRender = function() {
//         if (this.hasOwnProperty('data') && this.data !== null) {
//           var data = this.data;
//             for (var i = 0; i < data.length; i++) {
//               const prodId = data[i]['id'];
//               var productURL = localeURLPart + '/products/' + data[i].handle + '?sections=product-price';
//               console.log(productURL)
//               fetch(productURL).then(resposne => resposne.json()).then(resposne => {

//                 let priceHTML = resposne['product-price'];

//                 document.querySelector(`[data-id="${prodId}"]`).querySelector('.boost-pfs-search-suggestion-product-regular-price').innerHTML = priceHTML;
//               })
//         }
//       }
//     }

      InstantSearchResultItemProduct.prototype.afterRender = function() {
          if (this.hasOwnProperty('data') && this.data !== null) {
              var data = this.data;
           

              var hasShopifyRoutes = Shopify && Shopify.routes && typeof Shopify.routes.root != 'undefined';
              var localeURLPart = "";

              if (hasShopifyRoutes) {
                  localeURLPart = Shopify.routes.root.replace(/\/$/, '');
              }

            
              jQ('.boost-pfs-search-suggestion-item[data-id="' + data.id + '"] .boost-pfs-search-suggestion-product-price').empty();
               // for (var i = 0; i < data.length; i++) {
                      const prodId = data['id'];
                      var productURL = localeURLPart + '/products/' + data.handle + '?sections=product-price';
                      console.log(productURL)
                      fetch(productURL).then(resposne => resposne.json()).then(resposne => {

                        let priceHTML = resposne['product-price'];
                       

                         jQ('.boost-pfs-search-suggestion-item[data-id="' + prodId + '"] .boost-pfs-search-suggestion-product-price').html(priceHTML);
                      })
                // }
          }
      }
    // End Boost 218211

})();